export const PlannerPopoverScreen = {
  Settings: 0,
  ConnectAccount: 1,
  ConnectedCalendars: 2,
  DisconnectAccount: 3,
  Feedback: 4,
  AdjustCalendarView: 5,
  ManageAccounts: 6,
  AccountDetails: 7,
  DefaultCalendar: 8,
  FilterDueDateCards: 9,
};

export type PlannerPopoverScreenType =
  (typeof PlannerPopoverScreen)[keyof typeof PlannerPopoverScreen];
